import { render } from "./DemoTabs.vue?vue&type=template&id=44b59c75"
const script = {}

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Demo/DemoTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44b59c75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44b59c75', __exports__)) {
    console.log('reload')
    api.reload('44b59c75', __exports__)
  }
  
  module.hot.accept("./DemoTabs.vue?vue&type=template&id=44b59c75", () => {
    console.log('re-render')
    api.rerender('44b59c75', render)
  })

}


export default __exports__